import React from 'react';
import { Wind, Droplets, Wrench, ArrowUpRight } from 'lucide-react';

const SERVICES = [
  {
    icon: Wind,
    title: 'Air Conditioning',
    body: "Installation, servicing and emergency repairs for residential and commercial air-conditioning systems. We\u2019ll keep your space comfortable and your system running efficiently.",
    cta: 'Air-Conditioning Services',
    href: '#air-conditioning',
  },
  {
    icon: Droplets,
    title: 'Leak Detection',
    body: 'Fast, non-invasive detection of hidden water leaks using specialist technology. We locate the source accurately, helping to minimise damage and avoid unnecessary disruption.',
    cta: 'Find a Leak',
    href: '#leak-detection',
  },
  {
    icon: Wrench,
    title: 'Plumbing',
    body: 'Reliable plumbing support, from urgent repairs and burst pipes to routine maintenance and installations across London.',
    cta: 'Plumbing Services',
    href: '#plumbing',
  },
];

export default function Services() {
  return (
    <section id="services" className="relative py-28 md:py-36 border-b border-[var(--line)]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="label-mono text-[var(--accent)] mb-6" data-reveal>Our Services</div>
        <h2 className="font-display text-[clamp(2rem,5vw,4rem)] max-w-4xl text-white" data-reveal>
          One desk, three <span className="font-display-italic text-[#c3cbdb]">disciplines.</span>
        </h2>

        <div className="mt-16 grid md:grid-cols-3 gap-6 lg:gap-8">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.title}
                data-reveal
                data-delay={i * 80}
                className="group relative flex flex-col border border-[var(--line)] bg-[var(--card)] p-8 lg:p-10 hover-card-lift overflow-hidden"
              >
                <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-[var(--accent)] to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

                <span className="w-14 h-14 rounded-md bg-[var(--card-2)] border border-[var(--line-strong)] flex items-center justify-center text-[var(--accent)] group-hover:bg-[var(--accent)] group-hover:text-white transition-colors duration-300">
                  <Icon size={26} strokeWidth={2} />
                </span>

                <h3 className="font-display text-[1.7rem] text-white mt-8">{s.title}</h3>
                <p className="mt-5 text-[15px] text-[var(--muted)] leading-relaxed flex-1">{s.body}</p>

                <a
                  href={s.href}
                  className="btn-accent mt-9 inline-flex items-center justify-center gap-3 rounded-md px-6 py-4 label-mono tracking-[0.14em] text-[0.72rem] w-full"
                >
                  {s.cta} <ArrowUpRight size={15} strokeWidth={2.4} />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
